export default class Rotina {
  constructor(id, nome) {
    this.id = id
    this.nome = nome
  }
}
